document.addEventListener('DOMContentLoaded', function () {
  // 下浮现动画
  gsap.utils.toArray('.animate-fade-down').forEach(element => {
    gsap.fromTo(
      element,
      { y: -50, opacity: 0 },  // 从上方进入
      {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: element,
          start: "top 68%",
          toggleActions: "play none none none"
        }
      }
    );
  });

  // 上浮现动画
  gsap.utils.toArray('.animate-fade-up').forEach(element => {
    gsap.fromTo(
      element,
      { y: 50, opacity: 0 }, // 从下方进入
      {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: element,
          start: "top 68%",
          toggleActions: "play none none none"
        }
      }
    );
  });

  // 左浮现动画
  gsap.utils.toArray('.animate-fade-left').forEach(element => {
    gsap.fromTo(
      element,
      { x: -50, opacity: 0 },  // 从左侧进入
      {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: element,
          start: "top 68%",
          toggleActions: "play none none none"
        }
      }
    );
  });

  // 右浮现动画
  gsap.utils.toArray('.animate-fade-right').forEach(element => {
    gsap.fromTo(
      element,
      { x: 50, opacity: 0 },   // 从右侧进入
      {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: element,
          start: "top 68%",
          toggleActions: "play none none none"
        }
      }
    );
  });
})

imagesLoaded(document.body, { background: true }, () => {
  ScrollTrigger.refresh();
});